import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "onDismiss", "className"];
/* eslint-disable max-classes-per-file */
import React from 'react';
import URI from 'urijs';
import { Button } from '../Button';
import { withFlowWebContext } from '../FlowWebProvider/withFlowWebContext';
import { CloseIcon } from '../icons';
import { Overlay } from '../Overlay';
import { useTranslate } from '../util';
import { forwardDataAttributes, setDataAttributes } from '../util/getDataAttributes';
import * as modalManager from './manager';
import { StyledCloseDiv, StyledFullScreenModal, StyledMainRegion, StyledModal, StyledModalFooter, StyledModalHeader, StyledModalTitle } from './Modal.styled';
export var _Modal = /*#__PURE__*/function (_React$Component) {
  function _Modal() {
    var _this;
    _classCallCheck(this, _Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _Modal, [].concat(args));
    _defineProperty(_this, "isClosing", false);
    _defineProperty(_this, "modalRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "focusRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "elementFocusedOnOpen", document.activeElement);
    _defineProperty(_this, "removeHistoryListener", void 0);
    _defineProperty(_this, "stopIfNotBubbled", function (eventType, e) {
      var _this$props$bubbleEve;
      if ((_this$props$bubbleEve = _this.props.bubbleEvents) !== null && _this$props$bubbleEve !== void 0 && _this$props$bubbleEve.includes(eventType)) {
        return;
      }
      e.stopPropagation();
    });
    _defineProperty(_this, "handleKeyDown", function (e) {
      var _this$props$closeOnEs = _this.props.closeOnEscape,
        closeOnEscape = _this$props$closeOnEs === void 0 ? true : _this$props$closeOnEs;
      if (closeOnEscape && e.keyCode === 27 && modalManager.isTopModal(_this)) {
        _this.close();
      }
    });
    _defineProperty(_this, "handlePopState", function () {
      _this.close();
    });
    _defineProperty(_this, "handleHashChange", function (ev) {
      var newURL = ev.newURL;
      var newFragment = new URI(newURL || '').fragment();
      var isRouterStateChange = newFragment.includes('?_k=');
      if (!isRouterStateChange) {
        _this.close();
      }
    });
    _defineProperty(_this, "close", function () {
      if (_this.isClosing) {
        return;
      }
      _this.isClosing = true;
      _this.tryDismiss();
    });
    _defineProperty(_this, "tryDismiss", function () {
      if (!_this.props.onDismiss) {
        throw new Error('[flow-web] the Modal component expects the onDismiss prop to be supplied from the component passed to showModal. ' + 'Did you forget to spread props into Modal?');
      }
      _this.props.onDismiss();
    });
    _defineProperty(_this, "focusFirst", function () {
      var elements = _this.getFocusableElements();
      if (elements) {
        var firstElement = elements[0];
        firstElement.focus();
      }
    });
    _defineProperty(_this, "focusLast", function () {
      var elements = _this.getFocusableElements();
      if (elements) {
        var lastElement = elements[elements.length - 1];
        lastElement.focus();
      }
    });
    return _this;
  }
  _inherits(_Modal, _React$Component);
  return _createClass(_Modal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$className = this.props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className;
      var _StyledModal = this.props.isFullScreen ? StyledFullScreenModal : StyledModal;
      return /*#__PURE__*/React.createElement(Overlay, {
        isFullScreen: this.props.isFullScreen,
        isOpen: this.props.isOpen || false,
        closeOnOverlayClick: this.props.closeOnOverlayClick,
        onDismiss: this.close,
        overlayClassName: this.props.overlayClassName
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        onFocus: this.focusLast
      }), /*#__PURE__*/React.createElement(_StyledModal, _extends({
        className: className,
        ref: this.modalRef,
        onChange: function onChange(e) {
          return _this2.stopIfNotBubbled('onChange', e);
        },
        onClick: function onClick(e) {
          return _this2.stopIfNotBubbled('onClick', e);
        },
        onContextMenu: function onContextMenu(e) {
          return _this2.stopIfNotBubbled('onContextMenu', e);
        },
        onDoubleClick: function onDoubleClick(e) {
          return _this2.stopIfNotBubbled('onDoubleClick', e);
        },
        onDrag: function onDrag(e) {
          return _this2.stopIfNotBubbled('onDrag', e);
        },
        onDragEnd: function onDragEnd(e) {
          return _this2.stopIfNotBubbled('onDragEnd', e);
        },
        onDragEnter: function onDragEnter(e) {
          return _this2.stopIfNotBubbled('onDragEnter', e);
        },
        onDragExit: function onDragExit(e) {
          return _this2.stopIfNotBubbled('onDragExit', e);
        },
        onDragLeave: function onDragLeave(e) {
          return _this2.stopIfNotBubbled('onDragLeave', e);
        },
        onDragOver: function onDragOver(e) {
          return _this2.stopIfNotBubbled('onDragOver', e);
        },
        onDragStart: function onDragStart(e) {
          return _this2.stopIfNotBubbled('onDragStart', e);
        },
        onDrop: function onDrop(e) {
          return _this2.stopIfNotBubbled('onDrop', e);
        },
        onInput: function onInput(e) {
          return _this2.stopIfNotBubbled('onInput', e);
        },
        onInvalid: function onInvalid(e) {
          return _this2.stopIfNotBubbled('onInvalid', e);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.stopIfNotBubbled('onKeyDown', e);
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.stopIfNotBubbled('onKeyPress', e);
        },
        onKeyUp: function onKeyUp(e) {
          return _this2.stopIfNotBubbled('onKeyUp', e);
        },
        onMouseDown: function onMouseDown(e) {
          return _this2.stopIfNotBubbled('onMouseDown', e);
        },
        onMouseEnter: function onMouseEnter(e) {
          return _this2.stopIfNotBubbled('onMouseEnter', e);
        },
        onMouseLeave: function onMouseLeave(e) {
          return _this2.stopIfNotBubbled('onMouseLeave', e);
        },
        onMouseMove: function onMouseMove(e) {
          return _this2.stopIfNotBubbled('onMouseMove', e);
        },
        onMouseOut: function onMouseOut(e) {
          return _this2.stopIfNotBubbled('onMouseOut', e);
        },
        onMouseOver: function onMouseOver(e) {
          return _this2.stopIfNotBubbled('onMouseOver', e);
        },
        onMouseUp: function onMouseUp(e) {
          return _this2.stopIfNotBubbled('onMouseUp', e);
        }
      }, setDataAttributes(this.props, 'modal'), {
        role: "dialog",
        "aria-modal": "true",
        title: this.props.title ? this.props.title : undefined
      }), /*#__PURE__*/React.createElement("div", {
        tabIndex: -1,
        ref: this.focusRef
      }), this.props.isFullScreen ? this.props.children : /*#__PURE__*/React.createElement(React.Fragment, null, this.props.title && /*#__PURE__*/React.createElement(ModalHeader, _extends({
        onDismiss: this.close
      }, forwardDataAttributes(this.props)), /*#__PURE__*/React.createElement(ModalTitle, null, this.props.title)), this.props.children)), /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        onFocus: this.focusFirst
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      modalManager.addModal(this);
      window.addEventListener('keydown', this.handleKeyDown, true);
      if (!this.props.isRouted) {
        window.history.pushState({}, 'emptyState');
        window.addEventListener('popstate', this.handlePopState);
        if (this.props.isFullScreen) {
          window.addEventListener('hashchange', this.handleHashChange);
        }
        if (this.props.flowWebConfig.history) {
          this.removeHistoryListener = this.props.flowWebConfig.history.listen(this.close);
        }
      }
      var _this$props$autoFocus = this.props.autoFocus,
        autoFocus = _this$props$autoFocus === void 0 ? true : _this$props$autoFocus;
      if (autoFocus) {
        var _this$focusRef$curren;
        (_this$focusRef$curren = this.focusRef.current) === null || _this$focusRef$curren === void 0 ? void 0 : _this$focusRef$curren.focus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$elementFocusedO, _this$elementFocusedO2;
      modalManager.removeModal(this);
      window.removeEventListener('keydown', this.handleKeyDown, true);
      if (!this.props.isRouted) {
        var _this$removeHistoryLi;
        window.removeEventListener('popstate', this.handlePopState);
        if (this.props.isFullScreen) {
          window.removeEventListener('hashchange', this.handleHashChange);
        }
        (_this$removeHistoryLi = this.removeHistoryListener) === null || _this$removeHistoryLi === void 0 ? void 0 : _this$removeHistoryLi.call(this);
      }
      (_this$elementFocusedO = this.elementFocusedOnOpen) === null || _this$elementFocusedO === void 0 ? void 0 : (_this$elementFocusedO2 = _this$elementFocusedO.focus) === null || _this$elementFocusedO2 === void 0 ? void 0 : _this$elementFocusedO2.call(_this$elementFocusedO);
    }
  }, {
    key: "getFocusableElements",
    value: function getFocusableElements() {
      var _this$modalRef$curren;
      return (_this$modalRef$curren = this.modalRef.current) === null || _this$modalRef$curren === void 0 ? void 0 : _this$modalRef$curren.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }
  }]);
}(React.Component);
export var Modal = withFlowWebContext(_Modal);
export var FullScreenModal = /*#__PURE__*/function (_React$Component2) {
  function FullScreenModal(props) {
    var _this3;
    _classCallCheck(this, FullScreenModal);
    _this3 = _callSuper(this, FullScreenModal, [props]);
    if (props.setFullscreen && props.modalId) {
      props.setFullscreen(props.modalId);
    }
    return _this3;
  }
  _inherits(FullScreenModal, _React$Component2);
  return _createClass(FullScreenModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, _extends({}, this.props, {
        isFullScreen: true
      }));
    }
  }]);
}(React.Component);
export function ModalHeader(_ref) {
  var children = _ref.children,
    onDismiss = _ref.onDismiss,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(StyledModalHeader, {
    className: className
  }, onDismiss && /*#__PURE__*/React.createElement(StyledCloseDiv, null, /*#__PURE__*/React.createElement(Button.IconOnly, _extends({
    type: "button",
    title: t('citrix-ui:close'),
    onClick: onDismiss,
    icon: CloseIcon,
    size: 22
  }, setDataAttributes(props, 'modal-close')))), children);
}
export function ModalBody(_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  return /*#__PURE__*/React.createElement(StyledMainRegion, {
    className: className
  }, children);
}
export function ModalFooter(_ref3) {
  var children = _ref3.children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className;
  return /*#__PURE__*/React.createElement(StyledModalFooter, {
    className: className
  }, children);
}
export function ModalTitle(_ref4) {
  var children = _ref4.children,
    _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className;
  return /*#__PURE__*/React.createElement(StyledModalTitle, {
    className: className
  }, children);
}